import { Trans, useLingui } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import { FiltersButton } from '@/design_system/Filters/FiltersButton/FiltersButton';
import { FilterDivider, FiltersMenu } from '@/design_system/Filters/FiltersMenu/FiltersMenu';
import InputSearch from '@/design_system/InputSearch';
import Stack from '@/design_system/Stack';
import IconCross from '@/icons/Cross.svg';

import { useFilters } from '../FiltersState';
import { useShowWarrantyTypeFilter } from '../utils';

import { FiltersApplicant } from './FiltersApplicant';
import { FiltersBrand } from './FiltersBrand';
import { FiltersCollaborator } from './FiltersCollaborator';
import { FiltersCreatedAt } from './FiltersCreatedAt';
import { FiltersServiceType } from './FiltersServiceType';
import { FiltersStep } from './FiltersStep';
import { FiltersStockLocation } from './FiltersStockLocation';
import { FiltersStore } from './FiltersStore';
import { FiltersSubLocation } from './FiltersSubLocation';
import { FiltersSupervisor } from './FiltersSupervisor';
import { FiltersTask } from './FiltersTask';
import { FiltersWarrantyType } from './FiltersWarrantyType';
import { FiltersWorkshop } from './FiltersWorkshop';

export const DesktopFilters = () => {
  const { t } = useLingui();
  const { search, activeFiltersCount, clearFilters } = useFilters();
  const showWarrantyTypeFilter = useShowWarrantyTypeFilter();

  return (
    <Stack gap="0.75rem">
      <Stack row gap="1rem" alignItems="center">
        <FiltersMenu button={<FiltersButton />}>
          <FiltersApplicant />
          <FiltersStep />
          <FiltersTask />
          <FiltersServiceType />
          {showWarrantyTypeFilter && <FiltersWarrantyType />}
          <FilterDivider />
          <FiltersStore />
          <FiltersWorkshop />
          <FiltersStockLocation />
          <FiltersSupervisor />
          <FiltersCollaborator />
          <FiltersBrand />
          <FiltersSubLocation />
          <FilterDivider />
          <FiltersCreatedAt />
        </FiltersMenu>
        <InputSearch
          ariaLabel={t({ id: 'requests.filters.search.label', message: 'Search requests' })}
          placeholder={t({
            id: 'requests.filters.search.placeholder',
            message: 'Search requests...',
          })}
          value={search.search}
          onChange={search.debouncedSetSearch}
          style={{ flex: 1 }}
        />
      </Stack>

      {activeFiltersCount > 0 && (
        <Stack row gap="1rem" justifyContent="space-between" alignItems="center" flexWrap="nowrap">
          <Stack row gap="0.5rem">
            <FiltersApplicant tag />
            <FiltersStep tag />
            <FiltersTask tag />
            <FiltersServiceType tag />
            {showWarrantyTypeFilter && <FiltersWarrantyType tag />}
            <FiltersStore tag />
            <FiltersWorkshop tag />
            <FiltersStockLocation tag />
            <FiltersSupervisor tag />
            <FiltersCollaborator tag />
            <FiltersBrand tag />
            <FiltersSubLocation tag />
            <FiltersCreatedAt tag />
          </Stack>

          <Button
            variant="link-subtle"
            onPress={clearFilters}
            style={{ textWrap: 'nowrap' }}
            size="small"
          >
            <IconCross />
            <Trans id="requests.filters.clear_all">Clear filters</Trans>
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
